import { createSlice } from '@reduxjs/toolkit';

export const exampleSlice = createSlice({
  name: 'example',
  initialState: {
    buttonClicked: false,
  },
  reducers: {
    toggleButton: (state) => {
      state.buttonClicked = !state.buttonClicked;
    },
  },
});

export const { toggleButton } = exampleSlice.actions;

export default exampleSlice.reducer;
